import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from '../../util/Api';

import {
  CREATE_JOB_CARD_ALLOCATION_SUCCESS,
  FETCH_JOB_CARD_ALLOCATION_SUCCESS,
  GET_JOB_CARD_ALLOCATION_SUCCESS,
  GET_LOCATION_BY_QUERY_IN_JOB_CARD_ALLOCATION,
  SAVE_JOB_CARD_ALLOCATION_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_JOB_CARD_ALLOCATION_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_JOB_CARD_ALLOCATION_QUERY,
    query,
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_JOB_CARD_ALLOCATION_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_JOB_CARD_ALLOCATION_SUCCESS,
    data,
  };
};

export const getLocationByQuerySuccess = ({ data }) => {
  return {
    type: GET_LOCATION_BY_QUERY_IN_JOB_CARD_ALLOCATION,
    data,
  };
};


export const getLocationByQuery = (locationQuery) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/location?locationQuery=${locationQuery}`);
      dispatch(fetchSuccess());
      dispatch(getLocationByQuerySuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { jobCardAllocation } = store.getState();
      const { query } = jobCardAllocation;
      const response = await axios.get(`/activity/job-card-allocation?${generateQueryString(query)}&location=${query.location}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { jobCardAllocation } = store.getState();
      const { query } = jobCardAllocation;
      const response = await axios.get(`/activity/job-card-allocation/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/job-card/allocate`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      history.push('/job-card/allocate');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log('Error****:', error);
    }
  };
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.put(`/activity/allocate`, payload);
      dispatch(fetchSuccess());
      history.push('/job-card-allocation');
      dispatch(getResource());
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/activity/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.delete(`/job-card/allocate/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};
